<template>
  <div class="p-4 flex flex-col items-center gap-y-2">
    <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-black font-bold leading-6">
      <slot></slot>
    </div>
    <RoomExamInfoItem v-for="(user, i) in users" :key="i" :user="user" />
  </div>
</template>

<script>
import RoomExamInfoItem from "@/components/Room/Exam/Info/RoomExamInfoItem.vue";

export default {
  name: 'RoomExamInfoForm',
  components: {
    RoomExamInfoItem
  },
  props: {
    users: { type: Object, default: () => ({}) },
  },
}
</script>